import React from 'react';
import { MultiSelect } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import Fuse from 'fuse.js';
function fuzzySearchParticipants(availableParticipants, search) {
    const maxResults = 5;
    if (!search) {
        return availableParticipants.slice(0, maxResults);
    }
    const fuse = new Fuse(availableParticipants, {
        includeScore: true,
        keys: ['fullName'],
    });
    return fuse
        .search(search)
        .slice(0, maxResults)
        .map((result) => result.item);
}
const InternalTagSelect = MultiSelect.ofType();
export function ParticipantsSelector(props) {
    const [selectedIds, setSelectedIds] = React.useState(props.selectedIds);
    const handleChange = (ids) => {
        setSelectedIds(ids);
        props.onChange(ids);
    };
    const renderItem = (participant, { modifiers, handleClick }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const selected = selectedIds.filter((id) => id === participant.id).length > 0;
        return (React.createElement(MenuItem, { active: false, selected: selected, icon: selected ? React.createElement("i", { className: "fal fa-check" }) : React.createElement("i", { className: "fal" }), key: participant.id, text: participant.fullName, onClick: handleClick, shouldDismissPopover: false }));
    };
    return (React.createElement(InternalTagSelect, { items: props.choices, selectedItems: props.choices.filter((participant) => selectedIds.includes(participant.id)), onItemSelect: (participant) => {
            if (selectedIds.includes(participant.id)) {
                handleChange(selectedIds.filter((id) => id !== participant.id));
            }
            else {
                handleChange(selectedIds.slice().concat([participant.id]));
            }
        }, itemRenderer: renderItem, tagRenderer: (participant) => participant.fullName, noResults: React.createElement(MenuItem, { disabled: true, text: "Aucun r\u00E9sultat" }), resetOnSelect: true, itemListPredicate: (query, participants) => fuzzySearchParticipants(participants, query), itemsEqual: (participant1, participant2) => participant1.id === participant2.id, fill: true, popoverProps: {
            minimal: true,
            usePortal: false,
        }, tagInputProps: {
            leftIcon: React.createElement("i", { className: "far fa-user" }),
            placeholder: 'Rechercher une personne',
            onRemove: (_, index) => handleChange(selectedIds.filter((id) => id !== selectedIds[index])),
        } }));
}
